import {
    GET_ADD_FORM_DATA,
    ADD_FORM_API_SUCCESS,
    ADD_FORM_API_FAIL,
    
} from "./actionTypes";

export const addFormApiSuccess = (data) => ({
    type: ADD_FORM_API_SUCCESS,
    payload: data ,
});

export const addFormApiFail = (actionType, error) => ({
    type: ADD_FORM_API_FAIL,
    payload: { actionType, error },
});


export const getaddFormData = (queryParam,callback) =>({
    type: GET_ADD_FORM_DATA,
    payload: queryParam,
    callback
})

